import { ref } from "vue";

export function useFiledropper(options?: {
	onStartFileDrop?: () => void;
	onEndFileDrop?: () => void;
	handleFileDrop?: (file: File) => void;
}) {
	const isDroppingFiles = ref(false);

	function startFileDrop(e: DragEvent) {
		const dt = e.dataTransfer;
		if (dt?.types && dt.types?.indexOf("Files") != -1) {
			isDroppingFiles.value = true;

			if (options?.onStartFileDrop) {
				options.onStartFileDrop();
			}
		}
	}

	function endFileDrop() {
		if (options?.onEndFileDrop) {
			options.onEndFileDrop();
		}

		isDroppingFiles.value = false;
	}

	function onFileDrop(ev: DragEvent) {
		endFileDrop();

		const handleFileDrop = options?.handleFileDrop
			? options.handleFileDrop
			: () => {};

		if (ev.dataTransfer?.items) {
			// Use DataTransferItemList interface to access the file(s)
			[...ev.dataTransfer.items].forEach((item) => {
				// If dropped items aren't files, reject them
				if (item.kind === "file") {
					const file = item.getAsFile();

					if (file) {
						handleFileDrop(file);
					}
				}
			});
		} else if (ev.dataTransfer?.files) {
			// Use DataTransfer interface to access the file(s)
			[...ev.dataTransfer.files].forEach((file) => {
				handleFileDrop(file);
			});
		}
	}

	return { isDroppingFiles, startFileDrop, endFileDrop, onFileDrop };
}
